import MDButton from "components/MDButton";
import { useNavigate } from "react-router-dom";
import { sendEmail } from "services/data.report.service";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { Grid, TextField, Box } from "@mui/material";
import { exportExcel } from "services/data.report.service";
import { sendEmail2 } from "services/data.report.service";

export const BackButton = ({ label = "Exit without save", url, state = null }) => {
  const navigate = useNavigate();
  return (
    <MDButton
      sx={{ marginLeft: "1.5rem" }}
      onClick={() => {
        if (state === null) {
          navigate(url);
        } else {
          navigate(url, { state });
        }
      }}
      variant="outlined"
      color="info"
    >
      {label}
    </MDButton>
  );
};

export const InfoButton = ({ children, ...v }) => {
  return (
    <MDButton {...v} variant="gradient" color="info">
      {children}
    </MDButton>
  );
};

export const EmailButton = ({ filename, fileData, headers = null, onSuccess, onError, customerCode, ...v }) => {
  const sendEmailMutation = useMutation(sendEmail, {});
  const [recipient, setRecipient] = useState("");
  const handleSendEmail = async () => {
    const formData = new FormData();
    formData.append("jsonData", JSON.stringify(fileData));
    formData.append("recipientEmail", recipient);
    formData.append("fileName", filename);
    formData.append("jsonHeaders", JSON.stringify(headers));
    formData.append("customerCode", customerCode);

    sendEmailMutation.mutate(formData, {
      onSuccess: (data) => {
        setRecipient("");
        onSuccess(data);
      },
      onError,
    });
  };
  return (
    <Box display="flex" alignItems="center" sx={{ gap: "0.75rem" }}>
      <MDButton
        color="info"
        onClick={handleSendEmail}
        disabled={!Boolean(recipient)}
        sx={{ flexShrink: 0, whiteSpace: "nowrap" }}
        {...v}
      >
        send email
      </MDButton>
      <TextField
        label="Recipients (separated by comma ',')"
        fullWidth
        value={recipient}
        onChange={(e) => setRecipient(e.target.value)}
      />
    </Box>
  );
};

export const ExportButton = ({ filename, fileData, headers = null, onError, ...v }) => {
  const exportExcelMutation = useMutation(exportExcel, {});
  const handleExport = async () => {
    const formData = new FormData();
    formData.append("jsonData", JSON.stringify(fileData));
    formData.append("jsonHeaders", JSON.stringify(headers));

    exportExcelMutation.mutate(formData, {
      onSuccess: (data) => {
        const fileInString = data.data.data;

      const byteCharacters = atob(fileInString);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${filename}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      onSuccess(data);
      },
      onError,
    });
  };
  return (
    <MDButton color="info" onClick={handleExport} {...v}>
      export
    </MDButton>
  );
};

export const EmailButton2 = ({ filename, onSuccess, onError, customerCode, startDate, endDate, type, dateType, ...v }) => {
  const sendEmailMutation = useMutation(sendEmail2, {});
  const [recipient, setRecipient] = useState("");
  const handleSendEmail = async () => {
    const formData = new FormData();
    formData.append("startDate", startDate);
    formData.append("recipientEmail", recipient);
    formData.append("fileName", filename);
    formData.append("endDate", endDate);
    formData.append("customerCode", customerCode);
    formData.append("type", type);
    formData.append("dateType", dateType);

    sendEmailMutation.mutate(formData, {
      onSuccess: (data) => {
        setRecipient("");
        onSuccess(data);
      },
      onError,
    });
  };
  return (
    <Box display="flex" alignItems="center" sx={{ gap: "0.75rem" }}>
      <MDButton
        color="info"
        onClick={handleSendEmail}
        disabled={!Boolean(recipient)}
        sx={{ flexShrink: 0, whiteSpace: "nowrap" }}
        {...v}
      >
        send email
      </MDButton>
      <TextField
        label="Recipients (separated by comma ',')"
        fullWidth
        value={recipient}
        onChange={(e) => setRecipient(e.target.value)}
      />
    </Box>
  );
};